<script setup>
import PayrollForm from './PayrollForm.vue';
import PayrollTable from './PayrollTable.vue';
</script>

<template>
  <div>
    <div class="mb-2">
      <RouterLink to="/payroll/upload" class="button is-light">
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
        <span class="ml-2">Upload</span>
      </RouterLink>
    </div>
    <div class="card sticky">
      <div class="card-content">
        <PayrollForm @form-changed="setForm" @calculate-taxes="calcTaxes" v-if="payroll.account.name" :institutions="payrollFiltered.institutions"/>
      </div>
    </div>

    <div class="card">
      <div class="card-content">
        <PayrollTable :payroll="payrollFiltered" :form="form" v-if="payroll.account.name" :edit="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import PayrollService from "../../services/payroll-service";

export default {
  computed: {
    payroll() {
      const payroll = JSON.parse(sessionStorage.payroll);
      this.filterPayroll(payroll);
      return payroll;
    }
  },
  data() {
    return {
      form: {},
      payrollFiltered: {account: {name: ''}, institutions: []}
    }
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`
    },
    setForm(form) {
        this.form = form;
        this.filterPayroll(this.payroll);
    },
    filterPayroll(payroll) {
      let initialDate = this.form.initialDate == null ? null : new Date(this.form.initialDate);
      let finalDate = this.form.finalDate == null ? null : new Date(this.form.finalDate);

      if (finalDate) finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth() + 2, 0);

      this.payrollFiltered = JSON.parse(JSON.stringify(payroll));

      this.payrollFiltered.payments.forEach(payment => {
        let paymentDate = new Date(payment.date);

        payment.active = true;

        if (this.form.selectedInstitutions != null && this.form.selectedInstitutions.length > 0 && !this.form.selectedInstitutions.includes(payment.sequence)) {
          payment.active = false;
          return;
        }

        if (initialDate && paymentDate < initialDate) {
          payment.active = false;
          return;
        }

        if (finalDate && paymentDate > finalDate) {
          payment.active = false;
          return;
        }
      });
    },
    async calcTaxes() {
      const payrollInput = JSON.parse(sessionStorage.payroll);

      const data = {
        payroll: payrollInput,
        fee: this.form.fee,
        citationDate: this.form.citationDate,
        initialDate: this.form.initialDate,
        finalDate: this.form.finalDate,
        selectedInstitutions: this.form.selectedInstitutions
      };

      this.isLoading = true;

      const payroll = await PayrollService.calcTaxes(data);
      this.payrollFiltered = payroll;
      sessionStorage.setItem('payrollFiltered', JSON.stringify(payroll));
      this.$router.push('/payroll/calc');
    }
  }
};
</script>

<style>
  .sticky {
    position: sticky;
    top: 0;
    z-index: 2;
  }
</style>